export default "__VITE_ASSET__3d620bb8__"